(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServantExceptionDurationComponentController', ServantExceptionDurationComponentController);

    function ServantExceptionDurationComponentController($scope, $state, translate, translatePartialLoader, $mdDialog, ServantCustom, entity, TimingInfo) {
        var $ctrl = this;
        $ctrl.newDate = null;
        $ctrl.addDuration = addDuration;
        $ctrl.removeDuration = removeDuration;
        $ctrl.startDate = new Date();
        $ctrl.endDate = null;
        $ctrl.startTime;
        $ctrl.endTime;
        // $ctrl.availablityMode='CLOSE';
        $ctrl.servantList = [];
        $ctrl.selectedServant = null;
        $ctrl.loadServants = loadServants;
        $ctrl.exdurations = [];
        $ctrl.errorMessage = null;
        $ctrl.isDateEqual = isDateEqual;
        $ctrl.showEndDate = false;
        $ctrl.getDurationBlockClass = getDurationBlockClass;
        $ctrl.okModal = okModal;
        $ctrl.closeModal = closeModal;
        $ctrl.isFullDay = isFullDay;

        loadAll();

        function loadAll() {

            translatePartialLoader.addPart('scheduleInfo');
            translatePartialLoader = translate.refresh();

            if (entity && entity.defaultServantId)
                $ctrl.defaultServantId = entity.defaultServantId;

            if (entity && entity.availabilityMode)
                $ctrl.availabilityMode = entity.availabilityMode;
            else
                $ctrl.availabilityMode = 'CLOSE';

            if (entity && entity.canSelectServant != null && entity.canSelectServant != undefined)
                $ctrl.canSelectServant = entity.canSelectServant;
            else
                $ctrl.canSelectServant = true;


            loadServants();
        }

        function loadServants() {
            //if servant_login just current servant must selected
            ServantCustom.findServantsByCompany().query(function (result) {
                $ctrl.servantList = result;
                setDefaultServant();

            });
        }


        function setDefaultServant() {
            if ($ctrl.servantList) {
                if ($ctrl.defaultServantId) {
                    angular.forEach($ctrl.servantList, function (srv) {
                        if (srv.id == $ctrl.defaultServantId) {
                            $ctrl.selectedServant = srv;
                            return;
                        }
                    });
                }
            }

        }


        Date.prototype.toLocalISOString = function () {
            var mm = this.getMonth() + 1; // getMonth() is zero-based
            var dd = this.getDate();
            if (mm < 10) mm = '0' + mm;
            if (dd < 10) dd = '0' + dd;

            return [this.getFullYear(), mm, dd].join('-'); // padding
        };


        function setOffDate() {
            //
            if ($ctrl.selectedDatePeriod != undefined) {
                $ctrl.selectedDatePeriod.offdays = [];
                angular.forEach($ctrl.offDates, function (val) {
                    var dateTemp = new Date(val.value);
                    if (dateTemp)
                        $ctrl.selectedDatePeriod.offdays.push({offDate: dateTemp.toLocalISOString()});
                });
            }
        }

        function addDuration() {

            $ctrl.errorMessage = null;
            if (!$ctrl.exdurations)
                $ctrl.exdurations = [];
            var dur = makeDurationObject();
            if (dur && $ctrl.startDate != null && $ctrl.endDate != null) {

                var persianDate = new JDate($ctrl.newDate);
                var hasAddedBefore = false;
                angular.forEach($ctrl.exdurations, function (val) {
                    if (val.startDate && val.endDate && val.startDate.toLocaleString() == $ctrl.startDate.toLocaleString() &&
                        ((!val.startTime && !$ctrl.startTime) || (val.startTime && $ctrl.startTime && val.startTime.toLocaleString() == $ctrl.startTime.toLocaleString())) &&
                        val.endDate.toLocaleString() == $ctrl.endDate.toLocaleString() &&
                        ((!val.endTime && !$ctrl.endTime) || (val.endTime && $ctrl.endTime && val.endTime.toLocaleString() == $ctrl.endTime.toLocaleString()))
                    )

                        hasAddedBefore = true;
                });
                if (!hasAddedBefore) {

                    $ctrl.exdurations.push(dur);
                } else {
                    alert('بازه زمانی مشخص شده تکراری است');
                }
            }
        }

        function alert(msg) {
            $ctrl.errorMessage = msg;
        }

        function makeDurationObject(ev) {
            if (!$ctrl.showEndDate)
                $ctrl.endDate = $ctrl.startDate;

            if ($ctrl.showEndDate && !$ctrl.endDate) {
                alert('تاریخ پایان را وارد کنید');
                return null;
            }

            if ($ctrl.showEndDate && $ctrl.startDate > $ctrl.endDate) {
                alert('تاریخ پایان باید بزرگتر از تاریخ شروع باشد');
                return null;
            }

            if (!$ctrl.startTime || !$ctrl.endTime) {
                alert('ساعت شروع و پایان را وارد کنید');
                return null;
            } else {

                return {
                    availabilityMode: $ctrl.availabilityMode,
                    startDate: $ctrl.startDate,
                    endDate: $ctrl.endDate,
                    startTime: $ctrl.startTime,
                    endTime: $ctrl.endTime
                };
            }

        }

        function removeDuration(date) {
            if ($ctrl.exdurations != undefined)
                $ctrl.exdurations = $ctrl.exdurations.filter(function (item) {
                    return item != date;
                });
        }

        function isDateEqual(startDate, endDate) {


            var start = new Date(startDate).toLocalISOString();
            var end = new Date(endDate).toLocalISOString();

            if (start == end)
                return true;

            return false;


        }

        function getDurationBlockClass(dur) {
            if (dur && dur.availabilityMode) {
                if (dur.availabilityMode == 'CLOSE')
                    return 'CloseDurationBlock';
                else
                    return 'OpenDurationBlock';
            }
        }


        function okModal() {
            if (!$ctrl.exdurations || $ctrl.exdurations.length == 0) {
                alert("هیچ زمانی انتخاب نشده است")
                return;
            }

            if (!$ctrl.selectedServant) {
                alert("پرسنل انتخاب نشده است")
                return;
            }

            setServant();
            var exceptionHelper = {};
            exceptionHelper.servantExceptionDurations = $ctrl.exdurations;

            TimingInfo.insertServantExceptionDuration().save(exceptionHelper, onSaveSuccess, onSaveError);

            function onSaveSuccess() {
                closeModal();
            }

            function onSaveError() {
                // alert("خطا در ثبت اطلاعات")
                return;
            }
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function setServant() {


            angular.forEach($ctrl.exdurations, function (dur) {
                dur.servantId = $ctrl.selectedServant.id;
            })
        }

        function isFullDay(item) {
            var date1 = new Date(item.startTime);
            var date2 = new Date(item.endTime);
            var diffTime = Math.abs(date2 - date1);

            if (diffTime / 1000 == 86340) {
                return true;
            }
            return false;
        }

    }

    var ServantExceptionDurationComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/servant-exception-duration/partial-form.servant-exception-duration.html',
        controller: ServantExceptionDurationComponentController,
        bindings: {
            defaultServantId: '=',
            availabilityMode: '=',
            canSelectServant: '=?'
        }

    };

    angular
        .module('tikonApp')
        .component('pfServantExceptionDuration', ServantExceptionDurationComponent)

    ServantExceptionDurationComponentController.$inject = ['$scope', '$state', '$translate', '$translatePartialLoader', '$mdDialog', 'ServantCustom', 'entity', 'TimingInfo'];


})();

